// extracted by mini-css-extract-plugin
module.exports = {"verifyUser":"VerifyUser_verifyUser__RIgx6","content":"VerifyUser_content__2SKBv","header":"VerifyUser_header__n58Ik","subHeader":"VerifyUser_subHeader__2cyN8"};